import { AdType } from "./types";
import { fillAdInfoColumns } from "./constants";

export const getColumns = (adType: AdType) =>
  fillAdInfoColumns[adType].map(columnTitle => ({ title: columnTitle }));
